export const dataByLang = {
  en: {
    projet: 'The Project',
    formField: 'this field cannot be blank',
    emailField: 'Not a valid email',
    urlField: 'Not a valid URL',
    datedu: 'Dated',
  },
  fr: {
    projet: 'Le Projet',
    formField: 'ce champ ne peut pas être vide',
    emailField: 'Email invalide',
    urlField: 'URL invalide',
    datedu: 'Daté du',
  },
  ar: {
    projet: 'المشروع',
    formField: 'لا يمكن أن يكون هذا الحقل فارغًا',
    emailField: 'البريد الإلكتروني غير صالح',
    urlField: 'رابط غير صالح',
    datedu: 'تاريخ النشر',
  },
}
